import React, { useState, useEffect } from 'react'
import Skeleton from 'react-loading-skeleton';
import { Link, useNavigate, useParams } from 'react-router-dom';
import Breadcrumbs from '../components/Breadcrumbs';
import ImageVideoSlider from '../components/ImageVideoSlider';
import NeubauProjekteDetailTabs from '../components/NeubauProjekteDetailTabs';
import Header_3 from '../headers/Header_3';
import ImageTitleTextButton from '../modules/ImageTitleTextButton';
import TitleTextButton from '../modules/TitleTextButton';
import MapComponent from '../components/MapComponent';
import NeubauProjekteImageVideo from '../components/NeubauProjekteImageVideo';
import SanierungenDetailTabs from '../modules/SanierungenDetailTabs';
import MedienPopupSlider from '../components/MedienPopupSlider';
import { BlocksRenderer } from '@strapi/blocks-react-renderer';
import SEO from '../components/Seo';
import Header_2 from '../headers/Header_2';

export const SanierungenDetail = () => {
    const [activeTab, setActiveTab] = useState("Tab_1");

    let { title } = useParams();
    const navigate = useNavigate();

    const [isLoading, setIsLoading] = useState(false);
    const [pageData, setPageData] = useState(null);
    const [modules, setModules] = useState(null);

    const [allData, setAllData] = useState(null);
    const [newModules, setNewModules] = useState(null);

    const [tabData, setTabData] = useState(null);
    const [bildInfoData, setBildInfoData] = useState(null);

    const [headerModules, setHeaderModules] = useState(null);

    const [formulare, setFormulare] = useState(null);

    const getPageData = async () => {
        setIsLoading(true)
        try {
            const response = await fetch("https://backend.bgzurlinden.ch/api/neubauprojekte-posts?pagination[limit]=100&populate[Bannerbereich][on][header.header-2-text-bild][populate][Bild]=true&populate[Bannerbereich][on][header.header-2-text-bild][populate][Videominiatur]=true&populate[Bannerbereich][on][header.header-2-text-bild][populate][Video]=true&populate[Bannerbereich][on][header.header-3-titel-text-bild][populate][Bild]=true&populate[Bannerbereich][on][header.header-3-titel-text-bild][populate][Button]=true&populate[Bannerbereich][on][header.header-3-titel-text-bild][populate][Videominiatur]=true&populate[Bannerbereich][on][header.header-3-titel-text-bild][populate][Video]=true&populate[Modul][on][modules.carousel-bild-re-text][populate][Bild]=true&populate[Modul][on][modules.carousel-bild-re-text][populate][Button][populate]=*&populate[Modul][on][modules.carousel-bild-re-text][populate][Videominiatur]=true&populate[Modul][on][modules.carousel-bild-re-text][populate][Video]=true&populate[Modul][on][modules.short-titel-titel-text-button][populate][Button][populate]=*&populate[Modul][on][modules.short-titel-titel-text-button][populate][PDF][populate]=*&populate[neubauprojekte_kategoriens][populate]=*&populate[Modul][on][modules.neubauprojekte-registerkarten-daten][populate][neubauprojekte_registerkarten_daten][populate][Modul][on][modules.carousel-bild-re-text][populate][Bild]=true&populate[Modul][on][modules.neubauprojekte-registerkarten-daten][populate][neubauprojekte_registerkarten_daten][populate][Modul][on][modules.carousel-bild-re-text][populate][Button]=*&populate[Modul][on][modules.neubauprojekte-registerkarten-daten][populate][neubauprojekte_registerkarten_daten][populate][Modul][on][modules.carousel-bild-re-text][populate][Videominiatur]=true&populate[Modul][on][modules.neubauprojekte-registerkarten-daten][populate][neubauprojekte_registerkarten_daten][populate][Modul][on][modules.carousel-bild-re-text][populate][Video]=true&populate[Modul][on][modules.neubauprojekte-registerkarten-daten][populate][neubauprojekte_registerkarten_daten][populate][Modul][on][modules.short-titel-titel-text-button][populate]=*&populate[Modul][on][modules.neubauprojekte-registerkarten-daten][populate][neubauprojekte_registerkarten_daten][populate][Modul][on][modules.quote][populate]=*&populate[Modul][on][modules.benefits][populate][Benefits_Data][populate][Icon][populate]=true&populate[Neubauprojekte_Tab_Data][populate][neubauprojekte_registerkarten_daten][populate][Modul][on][modules.short-titel-titel-text-button][populate]=*&populate[Neubauprojekte_Tab_Data][populate][neubauprojekte_registerkarten_daten][populate][Modul][on][modules.carousel-bild-re-text][populate][Bild]=true&populate[Neubauprojekte_Tab_Data][populate][neubauprojekte_registerkarten_daten][populate][Modul][on][modules.carousel-bild-re-text][populate][Button]=*&populate[Neubauprojekte_Tab_Data][populate][neubauprojekte_registerkarten_daten][populate][Modul][on][modules.carousel-bild-re-text][populate][Videominiatur]=true&populate[Neubauprojekte_Tab_Data][populate][neubauprojekte_registerkarten_daten][populate][Modul][on][modules.carousel-bild-re-text][populate][Video]=true&populate[Neubauprojekte_Tab_Data][populate][neubauprojekte_registerkarten_daten][populate][Modul][on][modules.benefits][populate][Benefits_Data][populate][Icon][populate]=true&populate[Standort][populate]=*&populate[Beitrags_Miniaturbild][populate]=true&populate[Modul][on][modules.facts-modul][populate][Facts][populate][Icon][populate]=*&populate[Modul][on][modules.adresse-modul][populate][Adresse][populate][Standort][populate]=*&populate[Sanierungen_Tab_Data][populate][sanierungen_registerkarten_daten][populate][Modul][on][modules.short-titel-titel-text-button][populate]=*&populate[Sanierungen_Tab_Data][populate][sanierungen_registerkarten_daten][populate][Modul][on][modules.carousel-bild-re-text][populate][Bild]=true&populate[Sanierungen_Tab_Data][populate][sanierungen_registerkarten_daten][populate][Modul][on][modules.benefits][populate][Benefits_Data][populate][Icon][populate]=true&populate[Sanierungen_Tab_Data][populate][sanierungen_registerkarten_daten][populate][Modul][on][modules.vorher-nachher-bild-und-text][populate][Vorher_Bild]=true&populate[Sanierungen_Tab_Data][populate][sanierungen_registerkarten_daten][populate][Modul][on][modules.vorher-nachher-bild-und-text][populate][Nachbild]=true&populate[sanierungen_tags][populate]=*&populate[Bild_Info][populate][Bild_Info_Daten][populate][Bild][populate]=true&populate[Metadaten]=*");


            // &populate[Modul][on][modules.vorher-nachher-bild-und-text][populate][Vorher_Bild]=true&populate[Modul][on][modules.vorher-nachher-bild-und-text][populate][Nachbild]=true


            // "https://backend.bgzurlinden.ch/api/sanierungen-beitrags?populate[Bannerbereich][on][header.header-3-titel-text-bild][populate][Bild]=true&populate[Bannerbereich][on][header.header-3-titel-text-bild][populate][Button]=true&populate[Modul][on][modules.short-titel-titel-text-button][populate][Button][populate]=*&populate[Modul][on][modules.short-titel-titel-text-button][populate][PDF][populate]=*&populate[Modul][on][modules.carousel-bild-re-text][populate][Bild]=true&populate[Modul][on][modules.carousel-bild-re-text][populate][Button][populate]=*&populate[Metadaten]=*&populate[Sanierungen_Tab_Data][populate][sanierungen_registerkarten_daten][populate][Modul][on][modules.short-titel-titel-text-button][populate]=*&populate[Sanierungen_Tab_Data][populate][sanierungen_registerkarten_daten][populate][Modul][on][modules.carousel-bild-re-text][populate][Bild]=true&populate[Sanierungen_Tab_Data][populate][sanierungen_registerkarten_daten][populate][Modul][on][modules.benefits][populate][Benefits_Data][populate][Icon][populate]=true&populate[Sanierungen_Tab_Data][populate][sanierungen_registerkarten_daten][populate][Modul][on][modules.vorher-nachher-bild-und-text][populate][Vorher_Bild]=true&populate[Sanierungen_Tab_Data][populate][sanierungen_registerkarten_daten][populate][Modul][on][modules.vorher-nachher-bild-und-text][populate][Nachbild]=true&populate[sanierungen_tags][populate]=*&populate[Bild_Info][populate][Bild_Info_Daten][populate][Bild][populate]=true"




            // &populate[Bild_Info][populate][Bild_Info_Daten][populate][Bild][populate]=true
            // Bild_Info

            // &populate[Tab_Data][populate][sanierungen_registerkarten_daten][populate][Modul][on][modules.vorher-nachher-bild-und-text][populate][Vorher_Bild]=true&populate[Tab_Data][populate][sanierungen_registerkarten_daten][populate][Modul][on][modules.vorher-nachher-bild-und-text][populate][Nachbild]=true

            // &populate[Tab_Data][populate][neubauprojekte_registerkarten_daten][populate][Modul][on][modules.benefits][populate][Benefits_Data][populate][Icon][populate]=true

            // &populate[Modul][on][modules.benefits][populate][Benefits_Data][populate][Icon][populate]=true

            // ?populate[Bannerbereich][on][header.header-3-titel-text-bild][populate][Button]=true

            // &populate[Modul][on][modules.neubauprojekte-registerkarten-daten][populate][neubauprojekte_registerkarten_daten][populate][Modul][on][modules.quote][populate]=*

            // &populate[Modul][on][modules.benefits][populate][Benefits_Data][populate][Icon][populate]=true

            // &populate[Modul][on][modules.benefits][populate][Benefits_Data][populate][Icon][populate]=true

            // &populate[Modul][on][modules.neubauprojekte-registerkarten-daten][populate][neubauprojekte_registerkarten_daten][populate][Modul][on][modules.short-titel-titel-text-button][populate]=*

            // &populate[neubauprojekte_registerkarten_daten][populate][Modul][on][modules.carousel-bild-re-text][populate][Bild]=true


            // &populate[Modul][on][modules.neubauprojekte-modul][populate][neubauprojekte_posts][populate][Bannerbereich][on][header.header-3-titel-text-bild][populate][Bild]=true&populate[Modul][on][modules.neubauprojekte-modul][populate][neubauprojekte_posts][populate][Modul][on][modules.carousel-bild-re-text][populate][Bild]=true&populate[Modul][on][modules.neubauprojekte-modul][populate][neubauprojekte_posts][populate][Modul][on][modules.short-titel-titel-text-button][populate]=*&populate[Modul][on][modules.neubauprojekte-modul][populate][neubauprojekte_posts][populate][neubauprojekte_kategorien][populate]=*&populate[Modul][on][modules.neubauprojekte-modul][populate][neubauprojekte_posts][populate][neubauprojekte_unterkategorien][populate]=*&populate[Modul][on][modules.neubauprojekte-modul][populate][neubauprojekte_posts][populate][Modul][on][modules.neubauprojekte-registerkarten-daten][populate][neubauprojekte_registerkarten_daten][populate][Modul][on][modules.carousel-bild-re-text][populate][Bild]=true&populate[Modul][on][modules.neubauprojekte-modul][populate][neubauprojekte_posts][populate][Modul][on][modules.neubauprojekte-registerkarten-daten][populate][neubauprojekte_registerkarten_daten][populate][Modul][on][modules.short-titel-titel-text-button][populate]=*

            const data = await response.json();

            if (data.data) {
                setFormulare(data.data);
                // setModules(data?.data?.Modul);
                // setHeaderModules(data?.data?.Bannerbereich);
            }


        }
        catch (error) {
            console.error(error);
        } finally {
            setIsLoading(false);
        }

    }

    useEffect(() => {
        getPageData();
    }, [])

    const [metaData, setMetaData] = useState(null);

    useEffect(() => {

        if (formulare?.length > 0 && title) {
            const matchedCategory = formulare?.find((category) => category.slug === title);
            if (matchedCategory) {
                console.log('matchedCategory', matchedCategory)
                setModules(matchedCategory?.Modul);
                setHeaderModules(matchedCategory?.Bannerbereich);
                setTabData(matchedCategory?.Sanierungen_Tab_Data);
                setBildInfoData(matchedCategory?.Bild_Info);

                setMetaData(matchedCategory?.Metadaten);

                fetchImages(matchedCategory?.Bild_Info);

                console.log('matchedCategory?.Bild_Info', matchedCategory?.Bild_Info);

            } else {
                navigate("/error"); // Redirect to trigger the catch-all error route
            }
        }


    }, [formulare, title]);


    const [imagesMap, setImagesMap] = useState({});

    // useEffect(() => {
    //     fetchImages();
    // }, [bildInfoData]);

    const fetchImages = async (bildInfoData) => {
        try {

            console.log('Fetching images for bildInfoData', bildInfoData);

            const response = await fetch(
                `https://backend.bgzurlinden.ch/api/upload/files`
            );

            const data = await response.json();

            const mappedImages = {};

            bildInfoData?.forEach((item) => {

                const imageId = item?.Bild?.image;

                const matchedImage = data.find(
                    (img) => img.documentId === imageId
                );

                if (matchedImage) {
                    mappedImages[imageId] = matchedImage;
                }
            });

            setImagesMap(mappedImages);

        } catch (err) {
            console.log(err);
        }
    };

    const [popupData, setPopupData] = useState(null);
    const [popupColor, setPopupColor] = useState(null);
    const [show, setShow] = useState(false);

    const showPopup = (infoData, color) => {
        setPopupData(infoData);
        setPopupColor(color);
        setShow(true);
    };

    const closePopup = () => {
        setPopupData(null);
        setShow(false);
    };

    return (
        <div className='page-content'>

            {metaData && <SEO seoData={metaData} />}

            {show && popupData && (
                <div className="modal medien_modal show d-block">
                    <div className="modal-dialog modal-xl modal-dialog-centered">
                        <div className="modal-content">
                            <div className="modal-body">
                                <button className="btn-close" onClick={closePopup}>
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64" fill="none" nighteye="disabled">
                                        <rect width="64" height="64" rx="32" fill={`var(--${popupColor})`} />
                                        <rect x="19.3203" y="21.1396" width="2.56" height="33.28" rx="1.28" transform="rotate(-45 19.3203 21.1396)" fill="white" />
                                        <rect x="42.8594" y="19.3301" width="2.56" height="33.28" rx="1.28" transform="rotate(45 42.8594 19.3301)" fill="white" />
                                    </svg>
                                </button>
                                <div className={`popup-container popup-${popupColor}`}>
                                    <div className='row'>
                                        <div className='col-lg-6 contnet-col'>
                                            <h2 className={`text-${popupColor} fs_50 fw-600`}>{popupData?.Titel}</h2>
                                            <h3 className="text-black fs_30 fw-600">{popupData?.Untertitel}</h3>
                                            {popupData?.Text && <BlocksRenderer content={popupData?.Text} />}
                                        </div>
                                        <div className='col-lg-6 image-col'>
                                            <MedienPopupSlider images={popupData?.Bild} showDownloadIcon={false} popupColor={popupColor} />
                                        </div>
                                        <div className='col-12 content-col mt-4 tick_list two_col'>
                                            {popupData?.Beschreibung && <BlocksRenderer content={popupData?.Beschreibung} />}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {!isLoading && (
                headerModules?.map((module, index) => (
                    <React.Fragment key={index}>
                        {module.__component === "header.header-2-text-bild" && (
                            <Header_2 module={module} isLoading={isLoading} title={module?.Titel} description={module?.Beschreibung} image={module?.Bild} sectionClass="banners-bauprojekte" activePage="Bauprojekte" activeInnerPage='sanierungen' />
                        )}
                    </React.Fragment>
                ))
            )}

            {!isLoading && (
                headerModules?.map((module, index) => (
                    <React.Fragment key={index}>
                        {module.__component === "header.header-3-titel-text-bild" && (
                            <Header_3 module={module} title={module?.Titel} description={module?.Beschreibung} image={module?.Bild} sectionClass="banners-bauprojekte" activePage="Bauprojekte" activeInnerPage='sanierungen' />
                        )}
                    </React.Fragment>
                ))
            )}

            {!isLoading ? (
                modules?.map((module, index) => (
                    <React.Fragment key={index}>
                        {module.__component === "modules.short-titel-titel-text-button" &&
                            <section className={`pt-pb-10 sec-blue-color ${module?.Padding_Top ? '' : 'pt-0'} ${module?.Padding_Bottom ? '' : 'pb-0'} ${module?.grauer_Hintergrundfarbe ? 'sec-bg-grey' : ''}`}>
                                <div className='container'>
                                    <TitleTextButton data={module} shortTitle={module?.Kurztitel} title={module?.Titel} text={module?.Text} buttons={module?.Button} component={module?.Komponente} pdf={module?.PDF} />
                                </div>
                            </section>
                        }
                        {module.__component === "modules.carousel-bild-re-text" &&
                            <ImageTitleTextButton module={module} shortTitle={module?.Kurztitel} images={module?.Bild} title={module?.Titel} description={module?.Beschreibung} buttons={module?.Button} sectionColor="blue" imagePosition={module?.Bildposition} equalCol={module?.Gleiche_Spalten} />
                        }
                        {module.__component === "modules.adresse-modul" &&
                            <section className={`pt-pb-10 sec-orange-color ${module?.Padding_Top ? '' : 'pt-0'} ${module?.Padding_Bottom ? '' : 'pb-0'} ${module?.grauer_Hintergrundfarbe ? 'sec-bg-grey' : ''}`}>
                                <div className='container'>
                                    <div className='zah_fakten_map mt-4'>
                                        <MapComponent locationData={module?.Adresse} localAddress={true} />
                                    </div>
                                </div>
                            </section>}
                        {module.__component === "modules.neubauprojekte-registerkarten-daten" &&
                            <section className={`pt-pb-10 sec-blue-color ${module?.Padding_Top ? '' : 'pt-0'} ${module?.Padding_Bottom ? '' : 'pb-0'}`}>
                                <div className='mt-4'>
                                    <NeubauProjekteDetailTabs allData={module?.neubauprojekte_registerkarten_daten} />
                                </div>
                            </section>}
                    </React.Fragment>
                ))
            ) : (
                <>
                    <section className={`banner_sec inner_banner wohnen-banner position-relative`}>
                        <div className='container'>
                            <div className='row'>
                                <div className='col-md-5 col-lg-4 banner-content pt-pb-10'>
                                    <h1>{<Skeleton count={1} />}</h1>
                                    <p>{<Skeleton count={3} />}</p>
                                </div>
                            </div>
                        </div>
                    </section>

                    <section className={`pt-pb-10 sec-orange-color`}>
                        <div className='container'>
                            <div className='title-text-button-module'>
                                {/* {shortTitle && <div className='subtitle'>{shortTitle}</div>} */}
                                <div className='row'>
                                    <div className='col-lg-5 title-col'>
                                        {/* {title && <h2 className='text-black mb-lg-4 mb-2'>{title}</h2>} */}
                                        <h2>{<Skeleton count={1} />}</h2>
                                    </div>
                                    <div className='col-lg-7 content-col mt-3 mt-lg-0 fw_strong_500'>
                                        <p>{<Skeleton count={3} />}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                </>
            )}


            <section className='pt-pb-10 pt-0 pb-0 sec-blue-color neubau_project_detail_sec'>

                <SanierungenDetailTabs allData={tabData} />

                <div className='multiple-locations-sec mt-10'>
                    <div className="container">
                        {bildInfoData?.map((item, index) => {

                            const imageId = item?.Bild?.image;
                            const image = imagesMap[imageId];

                            return (
                                <div key={index} className="hotspot-image-wrapper">

                                    <img
                                        src={`https://backend.bgzurlinden.ch${image?.url}`}
                                        alt=""
                                        className="main-image"
                                    />

                                    {item?.Bild?.hotspots?.map((spot, i) => (
                                        <button
                                            key={spot.id}
                                            className="hotspot-pin"
                                            style={{
                                                left: `${spot.x}%`,
                                                top: `${spot.y}%`,
                                                background: `var(--${item?.Bild_Info_Daten[i]?.Icon_Farbe?.split(" ")[0]})`,
                                                animationName: `pulse-animation-${item?.Bild_Info_Daten[i]?.Icon_Farbe?.split(" ")[0]}`,
                                            }}
                                            onClick={() => showPopup(item?.Bild_Info_Daten[i], item?.Bild_Info_Daten[i]?.Icon_Farbe?.split(" ")[0])}
                                        >
                                            <img src="https://backend.bgzurlinden.ch/uploads/Group_1597881211_9751cd1a10.svg" alt="" />
                                        </button>
                                    ))}

                                </div>
                            );
                        })}
                    </div>
                </div>


                {!isLoading && <div className='btn-container justify-content-center mt-4 mt-lg-5'>
                    <Link to="/sanierungen?id=projekte" className='button round_btn btn-blue-color'>
                        zur Übersicht
                        <span>
                            <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M20.7733 15.4513C20.7593 16.0532 20.2599 16.5526 19.6579 16.5667C19.056 16.5807 18.5794 16.1041 18.5934 15.5021L18.9037 2.20548L5.60703 2.51577C5.00507 2.52982 4.52846 2.05321 4.54251 1.45125C4.55657 0.849296 5.05594 0.349907 5.6579 0.33586L20.0445 0.000170705C20.6465 -0.0138708 21.1231 0.462731 21.109 1.06469L20.7733 15.4513Z" fill="inherit" />
                                <path d="M1.84309 20.7715C1.40751 21.2071 0.717391 21.2232 0.301672 20.8075C-0.114047 20.3918 -0.0979427 19.7017 0.337642 19.2661L19.2663 0.337392C19.7019 -0.0981931 20.3921 -0.114298 20.8078 0.301422C21.2235 0.717141 21.2074 1.40726 20.7718 1.84284L1.84309 20.7715Z" fill="inherit" />
                            </svg>
                        </span>
                    </Link>
                </div>}
            </section>
        </div>
    )
}